/**
 * Wipes browser storage on sign-out.
 *
 * A logout should leave nothing about the previous user behind, which matters
 * on the shared machines the console gets used from. `clear()` rather than
 * removing named keys, so a key added later is covered without anyone having
 * to remember to list it here.
 *
 * The trade-off is deliberate: this also drops the UI preferences
 * (`mdg.sidebarCollapsed`, `mdg.density`), so the next person to sign in gets
 * the defaults. If a preference should ever survive a logout it cannot live in
 * localStorage — read it back from the account instead.
 *
 * Both stores are guarded. Safari private mode throws on access, and a logout
 * that half-completed because storage was blocked is the worse outcome.
 */
export function clearClientStorage() {
  try {
    localStorage.clear();
  } catch {
    /* Blocked or unavailable. Nothing to fall back to. */
  }
  try {
    sessionStorage.clear();
  } catch {
    /* As above. */
  }

  /*
   * The density preference is also live on <html> as a data attribute, applied
   * before first paint in main.jsx. Clearing storage alone would leave the
   * previous user's density rendering on the login page until a reload, so the
   * attribute has to come off with it.
   */
  try {
    document.documentElement.removeAttribute('data-density');
  } catch {
    /* No DOM (SSR or a test env). Nothing to reset. */
  }
}
